import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { HiredPlacementSecondaryInfo } from "components/reusables";
import { AddEditHiredPlacementModal } from "components/reusables/AddEditModals/AddEditHiredPlacementModal";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getHiredPlacementStory } from "services";
import { generateFullName, URLPaths } from "utilities";

export function AdminHiredPlacementStoryDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditTeacherModal, setIsShowingEditTeacherModal] = useState(false);
  const promiseFn = useCallback(() => getHiredPlacementStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const teacher = data;
  const history = useHistory();

  const handleClick = () => {
    history.push("/map-view-admin");
  };

  if (!teacher && !isPending) return <Redirect to={URLPaths.mapViewAdmin} />;

  return (
    <>
      <PageContainer>
        <div>
          {teacher && (
            <Row>
              <Col xs={3}>
                <Img
                  src={teacher.photoUrl || ""}
                  placeholder={genericAvatar}
                  alt={`${teacher.firstName} ${teacher.lastName}`}
                  width="100%"
                  loading="lazy"
                  className="img-circle"
                />
                <hr />
                <HiredPlacementSecondaryInfo hiredPlacement={teacher} direction="column" />
                <hr />
                {/* <HiredPlacementContactInfo hiredPlacement={teacher} /> */}
              </Col>
              <Col>
                <Row>
                  <Col>
                    <h1>
                      {generateFullName(teacher.firstName, teacher.lastName)} {"(Alumni)"}{" "}
                    </h1>
                    <span>{`Class of ${teacher.gradYear}`}</span>
                  </Col>
                  <Col xs="auto">
                    <Button onClick={handleClick} variant="outline-danger">
                      Go Back
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button
                      variant="outline-success"
                      onClick={() => setIsShowingEditTeacherModal(true)}
                    >
                      Edit
                    </Button>
                  </Col>
                </Row>
                <hr />
                <Row>
                  {/* commented out because Sue Brondyk decided she didn't want a bio section
                   <Col xs={8}>
                    <h4>About</h4>
                    <p className="p-breaks">{teacher.bio}</p>
                  </Col> */}
                  <Col xs={10}>
                    {(teacher.quotes || []).length > 0 && (
                      <>
                        <h4>Quotes</h4>
                        <Card className="quotes">
                          <Card.Body>
                            {teacher.quotes?.map(quote => (
                              <HiredPlacementQuote key={quote} quote={quote} />
                            ))}
                          </Card.Body>
                        </Card>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          <ErrorModal error={error} />
        </div>
      </PageContainer>
      {!!teacher && (
        <AddEditHiredPlacementModal
          show={isShowingEditTeacherModal}
          setShow={setIsShowingEditTeacherModal}
          currentHiredPlacement={teacher}
        />
      )}
    </>
  );
}

interface HiredPlacementQuoteProps {
  quote: string;
}

function HiredPlacementQuote({ quote }: HiredPlacementQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
